if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          carousel: this.querySelector('swiper-container'),
          image: this.querySelector('[js-product-card="image"]'),
          links: this.querySelectorAll('[js-product-card="link"]'),
          swatches: this.querySelectorAll('[js-product-card="swatch"]'),
          swatchesCaption: this.querySelector('[js-product-card="swatchesCaption"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        [...this.nodeSelectors.swatches].forEach((element) => {
          element.addEventListener('click', this.handleSwatchClickEvent.bind(this));
        });
      }

      /**
       * Handles the swatch click event.
       * - Updates the thumbnail image.
       * @param {Event} event - The event payload.
       */
      handleSwatchClickEvent(event) {
        const swatch = event.currentTarget;

        this.nodeSelectors.image.srcset = this.nodeSelectors.image.srcset
          .split(',')
          .map((src) => src.trim())
          .map((src) => {
            const [width] = src.match(/(\d+)w$/);
            const url = new URL(swatch.dataset.variantImage, window.location.origin);

            url.searchParams.set('width', parseInt(width, 10));

            if (width) {
              return `${url.toString()} ${width}`;
            }

            return null;
          })
          .join(', ');

        this.nodeSelectors.image.src = swatch.dataset.variantImage;

        if (this.nodeSelectors.carousel?.swiper) {
          this.nodeSelectors.carousel.swiper.slideTo(0);
        }

        [...this.nodeSelectors.links].forEach((element) => {
          element.href = swatch.dataset.variantUrl;
        });

        [...this.nodeSelectors.swatches].forEach((element) => {
          if (element === swatch) {
            element.classList.add('is-active');
            return;
          }

          element.classList.remove('is-active');
        });

        if (this.nodeSelectors.swatchesCaption) {
          if (swatch.hasAttribute('data-value-name')) {
            this.nodeSelectors.swatchesCaption.textContent = swatch.dataset.valueName;
          }
        }

        this.dataset.variantId = swatch.dataset.variantId;
      }
    }
  );
}
